import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGroupTypeTrip = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 42,
	height: 42,
	viewBox: "0 0 42 42",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M42 0H0V42H42V0Z",
			fill: "#C9F9FB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.9999 36.86C25.7676 36.86 29.6326 35.9747 29.6326 34.8826C29.6326 33.7906 25.7676 32.9053 20.9999 32.9053C16.2322 32.9053 12.3672 33.7906 12.3672 34.8826C12.3672 35.9747 16.2322 36.86 20.9999 36.86Z",
			fill: "#00C0C9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.9999 26.4004C25.7676 26.4004 29.6326 22.4538 29.6326 17.5855C29.6326 12.7171 25.7676 8.77051 20.9999 8.77051C16.2322 8.77051 12.3672 12.7171 12.3672 17.5855C12.3672 22.4538 16.2322 26.4004 20.9999 26.4004Z",
			fill: "#00C0C9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.0015 25.5301C19.9053 25.5301 18.9158 24.6128 18.2152 22.9479C17.5777 21.4325 17.2266 19.43 17.2266 17.309C17.2266 15.188 17.5777 13.1854 18.2152 11.6701C18.9158 10.0052 19.9053 9.08789 21.0015 9.08789C22.0977 9.08789 23.0872 10.0052 23.7878 11.6701C24.4254 13.1854 24.7765 15.188 24.7765 17.309C24.7765 19.43 24.4254 21.4325 23.7878 22.9479C23.0872 24.6128 22.0977 25.5301 21.0015 25.5301ZM21.0015 10.1791C19.7323 10.1791 18.3186 13.1073 18.3186 17.3081C18.3186 21.509 19.7323 24.4372 21.0015 24.4372C22.2708 24.4372 23.6845 21.509 23.6845 17.3081C23.6845 13.1073 22.2708 10.1791 21.0015 10.1791Z",
			fill: "#C9F9FB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.6326 14.5352H12.3672V15.6272H29.6326V14.5352Z",
			fill: "#C9F9FB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.6326 18.9893H12.3672V20.0813H29.6326V18.9893Z",
			fill: "#C9F9FB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.9988 5.81152C14.635 5.81152 9.47656 10.97 9.47656 17.3338C9.47656 25.9068 20.9988 34.8831 20.9988 34.8831C20.9988 34.8831 32.5211 26.0841 32.5211 17.3338C32.5211 10.97 27.3627 5.81152 20.9988 5.81152ZM20.9988 24.4234C17.0685 24.4234 13.8832 21.2373 13.8832 17.3078C13.8832 13.3782 17.0693 10.1921 20.9988 10.1921C24.9284 10.1921 28.1145 13.3782 28.1145 17.3078C28.1145 21.2373 24.9284 24.4234 20.9988 24.4234Z",
			fill: "#00425C"
		})
	]
});
export default SvgGroupTypeTrip;
